import React from "react";

import Input from "../forms/Input";
import ColorCheckbox from "../forms/ColorCheckbox";
import BaseModal from "../modals/BaseModal";
import { CANVASSER_STATUS_COLORS } from "../../../utils/schedulerUtils";

export default class CanvasserLegend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //canvasser filters
      showAssignedCanvassers: true,
      availableCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      displayedCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
    };

    this.colorClassMapping = CANVASSER_STATUS_COLORS;
  }

  _handleLegendCheckboxToggle = (status) => {
    //check if status is in display
    let new_displayed_statuses;
    if (this.state.displayedCanvasserStatuses.includes(status)) {
      new_displayed_statuses = this.state.displayedCanvasserStatuses.filter(
        (d) => d !== status
      );
    } else {
      new_displayed_statuses = [
        ...this.state.displayedCanvasserStatuses,
        status,
      ];
    }

    this.setState({ displayedCanvasserStatuses: new_displayed_statuses });
  };

  render() {
    return (
      <BaseModal
        open={this.props.open}
        onClose={this.props.onClose}
        title="Filter Canvassers"
        onClick={() =>
          this.props.handleFilterUpdate(
            this.state.displayedCanvasserStatuses,
            this.state.showAssignedCanvassers
          )
        }
        center
      >
        <div className={"wrapper"} style={{ margin: "2em" }}>
          <Input
            type={"checkbox"}
            key={Math.random()}
            value={this.state.showAssignedCanvassers}
            defaultChecked={this.state.showAssignedCanvassers}
            onChange={() =>
              this.setState({
                showAssignedCanvassers: !this.state.showAssignedCanvassers,
              })
            }
            title={"Show Assigned"}
          />

          {this.state.availableCanvasserStatuses.map((d) => {
            return (
              <ColorCheckbox
                color={this.colorClassMapping[d].color}
                handleChange={() => this._handleLegendCheckboxToggle(d)}
                value={this.state.displayedCanvasserStatuses.includes(d)}
                title={
                  d.charAt(0).toUpperCase() + d.slice(1).replace(/_/g, " ")
                }
                key={d}
              />
            );
          })}
          <div className="button-wrapper">
            <button
              className="button"
              type={"submit"}
              onClick={() =>
                this.props.handleFilterUpdate(
                  this.state.displayedCanvasserStatuses,
                  this.state.showAssignedCanvassers
                )
              }
            >
              OK
            </button>
            <div
              className="button button-outline"
              onClick={() =>
                this.setState({
                  displayedCanvasserStatuses:
                    this.state.availableCanvasserStatuses,
                  showAssignedCanvassers: true,
                })
              }
            >
              Clear Filters
            </div>
          </div>
        </div>
      </BaseModal>
    );
  }
}
